import { DpCouponStrip } from '@/components/blocks/DpLibrary/DpCouponStrip';
import { DpMemberPromotionRender } from '@/components/blocks/DpMemberPromotionRender';
import { useUser } from '@/data/User';
import {
	buildDppLandingHref,
	getDppFirstName,
	getDppRedeemableTimeLeft,
} from '@/utils/dppPromotion';
import { DpContainer } from '@/components/blocks/DpContainer';

type DpDppCouponStripProps = {
	href?: string;
	button?: string;
	description?: string;
};

/**
 * Franja del home con el cupón DPP del cliente con sesión. Sin cupón que se pueda usar no muestra
 * nada: el banner principal del home queda igual.
 */
export const DpDppCouponStrip = ({ href, button, description }: DpDppCouponStripProps) => {
	const { user } = useUser();
	const firstName = getDppFirstName(user?.firstName);

	return (
		<DpMemberPromotionRender
			renderData={(promotion) => {
				const expiration = getDppRedeemableTimeLeft(promotion);
				if (!expiration) {
					return null;
				}
				return (
					<DpContainer>
						<DpCouponStrip
							name={firstName}
							discount={`${promotion.discountPercent}%`}
							description={description}
							expiration={expiration}
							button={button}
							href={href ? buildDppLandingHref(href, promotion, firstName) : undefined}
						/>
					</DpContainer>
				);
			}}
		/>
	);
};
